import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Typography,
  Box,
} from "@mui/material";
import { format } from "date-fns";
import Loading from "../ui/Loading";

const CallsDetailModal = ({
  open,
  onClose,
  filters,
  projectId,
  projectName,
  clientId,
  clientName,
  callsDetail,
  getCalls,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  useEffect(() => {
    if (open) {
      const customFilters = { ...filters };
      if (projectId) customFilters.projectId = projectId;
      if (clientId) customFilters.clientId = clientId;

      getCalls(customFilters, page + 1, rowsPerPage);
    }
  }, [open, page, rowsPerPage, filters, projectId, clientId]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const title = projectName
    ? `Calls for ${projectName}`
    : clientName
      ? `Calls for ${clientName}`
      : "Call Details";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {callsDetail.isLoading ? (
          <Loading />
        ) : callsDetail.error ? (
          <Typography color="error">{callsDetail.error}</Typography>
        ) : (
          <>
            <TableContainer sx={{ maxHeight: 500 }}>
              <Table
                stickyHeader
                size="small"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Schedule Date</TableCell>
                    <TableCell>Project</TableCell>
                    <TableCell>Client</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Street Address</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Completed</TableCell>
                    <TableCell>Billed</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {callsDetail.data?.map((call, index) => (
                    <TableRow
                      key={index}
                      hover
                    >
                      <TableCell>
                        {call.scheduleDate
                          ? format(new Date(call.scheduleDate), "MMM dd, yyyy")
                          : "-"}
                      </TableCell>
                      <TableCell>{call.projectName || "-"}</TableCell>
                      <TableCell>{call.clientName || "-"}</TableCell>
                      <TableCell>{call.locationName || "-"}</TableCell>
                      <TableCell>{call.streetAddress || "-"}</TableCell>
                      <TableCell>
                        <Box
                          component="span"
                          sx={{
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                            backgroundColor:
                              call.callStatus === "complete"
                                ? "success.light"
                                : call.callStatus === "incomplete"
                                  ? "warning.light"
                                  : "info.light",
                            color: "white",
                            fontSize: "0.75rem",
                          }}
                        >
                          {call.callStatus || "unknown"}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {call.completedOn
                          ? format(new Date(call.completedOn), "MMM dd, yyyy")
                          : "-"}
                      </TableCell>
                      <TableCell>{call.isBilled ? "Yes" : "No"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={callsDetail.total || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallsDetailModal;
